import React from "react";
import AppButton from "./AppButton";

/**
 * Reusable map-reports modal.
 *
 * Props:
 *   open                    - boolean
 *   personaName             - name shown in the header
 *   searchText              - current search value
 *   onSearchChange          - (e) => void
 *   selectedCount           - number of selected reports
 *   onSelectAll             - handler for Select All button
 *   onClearAll              - handler for Clear button
 *   reports                 - filtered reports array [{ id, name }]
 *   loading                 - boolean — shows loading state in list
 *   selectedIds             - array of selected report IDs
 *   onToggle                - (reportId) => void
 *   onSubmit                - form submit handler
 *   onClose                 - close handler
 */
const MapReportsModal = ({
  open,
  personaName,
  searchText,
  onSearchChange,
  selectedCount = 0,
  onSelectAll,
  onClearAll,
  reports = [],
  loading = false,
  selectedIds = [],
  onToggle,
  onSubmit,
  onClose,
  submitting = false,
}) => {
  if (!open) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content rr-manageCard">
            <div className="modal-header border-0 pb-1">
              <h5 className="modal-title">Map Reports — {personaName}</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            </div>

            <form onSubmit={onSubmit}>
              <div className="modal-body">
                <p className="text-muted mb-2">Select one or more reports to map with this persona.</p>

                <div className="rr-mapToolbar mb-3">
                  <input
                    type="text"
                    className="form-control rr-manageSearch"
                    placeholder="Search reports"
                    value={searchText}
                    onChange={onSearchChange}
                  />
                  <div className="rr-mapActions">
                    <span className="rr-mapCount">Selected: {selectedCount}</span>
                    <AppButton type="button" variant="outline" onClick={onSelectAll}>Select All</AppButton>
                    <AppButton type="button" variant="secondary" onClick={onClearAll}>Clear</AppButton>
                  </div>
                </div>

                <div className="rr-mapReportList">
                  {loading ? (
                    <div className="text-muted py-2">Loading...</div>
                  ) : reports.length === 0 ? (
                    <div className="text-muted py-2">No reports found for this search.</div>
                  ) : (
                    reports.map((report) => (
                      <label key={report.id} className="rr-mapReportItem">
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(report.id)}
                          onChange={() => onToggle(report.id)}
                        />
                        <span>{report.name}</span>
                      </label>
                    ))
                  )}
                </div>
              </div>

              <div className="modal-footer border-0 justify-content-end d-flex gap-2">
                <AppButton type="submit" variant="fill" disabled={submitting}>
                  {submitting ? "Adding..." : "Add Reports"}
                </AppButton>
                <AppButton type="button" variant="secondary" onClick={onClose} disabled={submitting}>Cancel</AppButton>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default MapReportsModal;
